import { render, staticRenderFns } from "./AIDialog.vue?vue&type=template&id=6d1febc0&scoped=true"
import script from "./AIDialog.vue?vue&type=script&lang=js"
export * from "./AIDialog.vue?vue&type=script&lang=js"
import style0 from "./AIDialog.vue?vue&type=style&index=0&id=6d1febc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1febc0",
  null
  
)

export default component.exports